import { useState } from "react";
import { Loader2, Download } from "lucide-react";
import { PageHero } from "@/components/Reveal";
import { API } from "@/lib/site";

const Admin = () => {
  const [key, setKey] = useState("");
  const [rows, setRows] = useState(null);
  const [contacts, setContacts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const [r1, r2] = await Promise.all([
        fetch(`${API}/admin/waitlist?key=${encodeURIComponent(key)}`),
        fetch(`${API}/admin/contacts?key=${encodeURIComponent(key)}`),
      ]);
      if (!r1.ok || !r2.ok) throw new Error("Clave incorrecta");
      setRows(await r1.json());
      setContacts(await r2.json());
    } catch (e) {
      setError(e.message);
      setRows(null);
      setContacts(null);
    }
    setLoading(false);
  };

  return (
    <div data-testid="admin-page">
      <PageHero eyebrow="Admin" lines={["Lista de espera", "y mensajes."]} />
      <section className="bg-cream px-6 sm:px-12 lg:px-20 pb-24">
        <div className="flex flex-wrap gap-4 items-end mb-10">
          <input
            type="password"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="Clave de administración"
            data-testid="admin-key-input"
            className="bg-transparent border-b border-ink/25 focus:border-gold outline-none py-3 w-64"
          />
          <button
            onClick={load}
            data-testid="admin-load-button"
            className="rounded-full bg-ink text-cream px-6 py-3 font-mono text-xs uppercase tracking-[0.18em] hover:bg-gold hover:text-ink transition-colors duration-300"
          >
            {loading ? <Loader2 size={14} className="animate-spin" /> : "Cargar"}
          </button>
          {rows && (
            <a
              href={`${API}/admin/export?kind=waitlist&key=${encodeURIComponent(key)}`}
              data-testid="admin-export-csv"
              className="inline-flex items-center gap-2 rounded-full border border-ink/30 px-6 py-3 font-mono text-xs uppercase tracking-[0.18em] hover:border-gold hover:text-gold transition-colors duration-300"
            >
              <Download size={14} /> Exportar CSV
            </a>
          )}
        </div>
        {error && <p className="text-gold mb-6" data-testid="admin-error">{error}</p>}

        {rows && (
          <div data-testid="admin-waitlist-table" className="mb-14 overflow-x-auto">
            <h2 className="font-serif text-2xl mb-4">Lista de espera — Academia ({rows.length})</h2>
            <table className="w-full text-sm border border-sand">
              <thead>
                <tr className="bg-ink text-cream font-mono text-[10px] uppercase tracking-[0.2em]">
                  <th className="text-left p-3">Fecha</th>
                  <th className="text-left p-3">Nombre</th>
                  <th className="text-left p-3">Teléfono</th>
                  <th className="text-left p-3">Email</th>
                  <th className="text-left p-3">Interés</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-t border-sand">
                    <td className="p-3">{new Date(r.created_at).toLocaleDateString("es-ES")}</td>
                    <td className="p-3">{r.nombre}</td>
                    <td className="p-3">{r.telefono}</td>
                    <td className="p-3">{r.email}</td>
                    <td className="p-3">
                      <span className={`font-mono text-[10px] uppercase tracking-[0.15em] px-2 py-1 ${r.interes === "alumna" ? "bg-gold text-ink" : "bg-ink text-gold"}`}>
                        {r.interes}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {contacts && (
          <div data-testid="admin-contacts-table" className="overflow-x-auto">
            <h2 className="font-serif text-2xl mb-4">Mensajes de contacto ({contacts.length})</h2>
            <table className="w-full text-sm border border-sand">
              <thead>
                <tr className="bg-ink text-cream font-mono text-[10px] uppercase tracking-[0.2em]">
                  <th className="text-left p-3">Fecha</th>
                  <th className="text-left p-3">Nombre</th>
                  <th className="text-left p-3">Contacto</th>
                  <th className="text-left p-3">Motivo</th>
                  <th className="text-left p-3">Mensaje</th>
                </tr>
              </thead>
              <tbody>
                {contacts.map((r) => (
                  <tr key={r.id} className="border-t border-sand align-top">
                    <td className="p-3 whitespace-nowrap">{new Date(r.created_at).toLocaleDateString("es-ES")}</td>
                    <td className="p-3">{r.nombre}</td>
                    <td className="p-3">{r.contacto}</td>
                    <td className="p-3">{r.motivo}</td>
                    <td className="p-3 max-w-xs">{r.mensaje}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
};

export default Admin;
